import React from 'react'
import { useSentryUser } from '../../hooks/use-sentry-user'

interface SentryUserProviderProps {
  children: React.ReactNode
}

export function SentryUserProvider({ children }: SentryUserProviderProps) {
  useSentryUser()

  return <>{children}</>
}
